import { Container } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import Typography from "@mui/material/Typography";
import { Stack } from "@mui/system";
import * as React from "react";
import Header from "../common/Header";

export default function StaffMenu() {
  return (
    <Box sx={{ mb: 10 }}>
      <Header />

      <Container maxWidth="xl">
        <Box
          sx={{
            marginTop: 4,
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Typography component="h5" variant="h6" align="left">
            メニュー
          </Typography>
        </Box>
        <Box
          sx={{
            margin: 1,
            display: "flex",
            flexDirection: "column",
            bgcolor: "#fff9c4"
          }}
        >
          <Box
            sx={{
              mt: 1,
              alignItems: "left",
              justifyContent: "left",
              paddingLeft: 2
            }}
          >
            <Typography component="h5" variant="h6" align="left">
              生徒用個人アカウント作成
            </Typography>
          </Box>
          <Box sx={{ alignItems: "center", justifyContent: "center" }}>
            <div>
              <Stack direction="row" spacing={5} sx={{ mt: 1 }} justifyContent="center" alignItems="center">
                <FormControl fullWidth sx={{ mr: 3, ml: 5 }}>
                  <Button variant="contained" href="/StudentInformationRegister" sx={{ bgcolor: "#82b1ff" }}>
                    生徒情報登録
                  </Button>
                </FormControl>
                <FormControl fullWidth sx={{ mr: 3, ml: 3 }}>
                  <Typography component="h5" variant="h6" align="left">
                    生徒情報を登録する
                  </Typography>
                </FormControl>
              </Stack>
              <Stack direction="row" spacing={5} sx={{ mt: 3 }} justifyContent="center" alignItems="center">
                <FormControl fullWidth sx={{ mr: 3, ml: 5 }}>
                  <Button variant="contained" href="/StudentInformationManagement" sx={{ bgcolor: "#82b1ff" }}>
                    生徒情報管理
                  </Button>
                </FormControl>
                <FormControl fullWidth sx={{ mr: 3, ml: 3 }}>
                  <Typography component="h5" variant="h6" align="left">
                    生徒情報を確認・変更する
                    <br />パスワードの変更はこちら
                  </Typography>
                </FormControl>
              </Stack>
            </div>
            <Box sx={{ mt: 3 }} />
          </Box>
        </Box>
        <Box
          sx={{
            margin: 1,
            mt: 3,
            display: "flex",
            flexDirection: "column",
            bgcolor: "#fff9c4"
          }}
        >
          <Box
            sx={{
              mt: 1,
              alignItems: "left",
              justifyContent: "left",
              paddingLeft: 2
            }}
          >
            <Typography component="h5" variant="h6" align="left">
              教職員による評価の実施
            </Typography>
          </Box>
          <Box sx={{ alignItems: "center", justifyContent: "center" }}>
            <div>
              <Stack direction="row" spacing={5} sx={{ mt: 1 }} justifyContent="center" alignItems="center">
                <FormControl fullWidth sx={{ mr: 3, ml: 5 }}>
                  <Button variant="contained" href="/EvaluationImplement" sx={{ bgcolor: "#82b1ff" }}>
                    評価実施
                  </Button>
                </FormControl>
                <FormControl fullWidth sx={{ mr: 3, ml: 3 }}>
                  <Typography component="h5" variant="h6" align="left">
                    対象の生徒を評価する
                  </Typography>
                </FormControl>
              </Stack>
              <Stack direction="row" spacing={5} sx={{ mt: 3 }} justifyContent="center" alignItems="center">
                <FormControl fullWidth sx={{ mr: 3, ml: 5 }}>
                  <Button variant="contained" href="/EvaluationAnalysis" sx={{ bgcolor: "#82b1ff" }}>
                    評価分析
                  </Button>
                </FormControl>
                <FormControl fullWidth sx={{ mr: 3, ml: 3 }}>
                  <Typography component="h5" variant="h6" align="left">
                    評価結果を印刷する
                  </Typography>
                </FormControl>
              </Stack>
            </div>
            <Box sx={{ mt: 3 }} />
          </Box>
        </Box>
        <Box
          sx={{
            margin: 1,
            mt: 3,
            display: "flex",
            flexDirection: "column",
            bgcolor: "#fff9c4"
          }}
        >
          <Box
            sx={{
              mt: 1,
              alignItems: "left",
              justifyContent: "left",
              paddingLeft: 2
            }}
          >
            <Typography component="h5" variant="h6" align="left">
              その他
            </Typography>
          </Box>
          <Box sx={{ alignItems: "center", justifyContent: "center" }}>
            <div>
              <Stack direction="row" spacing={5} sx={{ mt: 1 }} justifyContent="center" alignItems="center">
                <FormControl fullWidth sx={{ mr: 3, ml: 5 }}>
                  <Button variant="contained" href="/Printing" sx={{ bgcolor: "#82b1ff" }}>
                    印刷
                  </Button>
                </FormControl>
                <FormControl fullWidth sx={{ mr: 3, ml: 3 }}>
                  <Typography component="h5" href="/Printing" variant="h6" align="left">
                    評価結果を印刷する
                  </Typography>
                </FormControl>
              </Stack>
            </div>
            <Box sx={{ mt: 3 }} />
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
